/* Rewrite footer internal links to the active market subfolder. */
(function () {
  try {
    var match = location.pathname.match(/^\/((?:de|en)-[a-z]{2})(?:\/|$)/);
    if (!match) return;

    var prefix = '/' + match[1];
    var marketPrefixPattern = /^\/((?:de|en)-[a-z]{2})(?=\/|$)/;

    // Leave language/market switcher links untouched — they intentionally target other subfolders.
    document.querySelectorAll('.footer-zenbox a[href^="/"]:not(.footer-zenbox__market-lang-btn)').forEach(function (anchor) {
      var href = anchor.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return;

      var hashIndex = href.indexOf('#');
      var hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
      var path = hashIndex >= 0 ? href.slice(0, hashIndex) : href;
      var existingPrefix = path.match(marketPrefixPattern);

      if (existingPrefix) {
        path = path.replace(marketPrefixPattern, '');
        if (path === '') path = '/';
      }

      if (path.indexOf(prefix + '/') !== 0 && path !== prefix) {
        anchor.setAttribute('href', prefix + path + hash);
      }
    });
  } catch (error) {
    // Non-critical footer link fix
  }
})();
